import { DockedQuestionCard } from '@/components/rooms';
import { Button } from '@/components/ui/shadcn';

import { COPY } from '../copy';
import { PANEL_CLICK_GUARD_MS, useClickGuard } from '../hooks/useClickGuard';

export interface RestartDockProps {
  /** Forget this onboarding and begin another. */
  onRestart: () => void;
  /** Clicks are ignored this long after the card mounts: it takes the place of the Build button that was just pressed. */
  clickGuardMs?: number;
}

/** The docked card after "Build my assessment": the only way to onboard a second brand in the same browser. */
export function RestartDock({ onRestart, clickGuardMs = PANEL_CLICK_GUARD_MS }: RestartDockProps) {
  const guard = useClickGuard(clickGuardMs);
  return (
    <DockedQuestionCard
      focusHeading
      title={COPY.startNewTitle}
      footer={
        <>
          <span className="flex-1" />
          <Button type="button" variant="ghost" size="xs" onClick={guard(onRestart)}>
            {COPY.startNew}
          </Button>
        </>
      }
    />
  );
}
